export class IncompleteDetailsForAgreement {
    public Age: number;
    public Age1: number;
    public PANNo: string;
    public PANNo1: string;
    public ApplicantType: string;
    public Gender: string;
    public Gender1: string;
    public BoardResolutionDate: Date;
    public HasGPA: boolean;
}